<ui-icon-bs
    [pseudo]="'white'"
    [type]="bsIconTypes.FiletypeXlsx"
    [titleText]="'global.labels.export' | translate"
    (handlerClick)="handlerExport()" />
